/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1ClassroomdisciplineClassModulesId202,
  DeleteApiV1ClassroomdisciplineClassModulesId401,
  DeleteApiV1ClassroomdisciplineClassModulesId404,
  DeleteApiV1ClassroomdisciplineClassModulesId500,
  DeleteApiV1ClassroomdisciplineClassModulesIdMutationResponse,
  DeleteApiV1ClassroomdisciplineClassModulesIdPathParams,
} from "../../types/classPlanningClassModuleController/DeleteApiV1ClassroomdisciplineClassModulesId.ts";

export const deleteApiV1ClassroomdisciplineClassModulesIdPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
  }) as unknown as ToZod<DeleteApiV1ClassroomdisciplineClassModulesIdPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const deleteApiV1ClassroomdisciplineClassModulesId202Schema =
  z.any() as unknown as ToZod<DeleteApiV1ClassroomdisciplineClassModulesId202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1ClassroomdisciplineClassModulesId401Schema =
  z.any() as unknown as ToZod<DeleteApiV1ClassroomdisciplineClassModulesId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1ClassroomdisciplineClassModulesId404Schema =
  z.any() as unknown as ToZod<DeleteApiV1ClassroomdisciplineClassModulesId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1ClassroomdisciplineClassModulesId500Schema =
  z.any() as unknown as ToZod<DeleteApiV1ClassroomdisciplineClassModulesId500>;

export const deleteApiV1ClassroomdisciplineClassModulesIdMutationResponseSchema =
  z.lazy(
    () => deleteApiV1ClassroomdisciplineClassModulesId202Schema,
  ) as unknown as ToZod<DeleteApiV1ClassroomdisciplineClassModulesIdMutationResponse>;
